import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface EstimateDetialRequest {
    // category: string;
    list_no: string;
}

export interface EstimateDetailResponse {
    statusCode: number;
    message: string;
    data: {
        w_date: string;
        e_company: string;
        e_name: string;
        e_tel: string;
        e_email: string;
        e_start: string;
        e_end: string;
        e_weight: string;
        e_pay: string;
        e_memo: string;
        result: string;
        result_text: string;
    };
}

export const useGetConsoleEstimateDetail = ({ list_no }: EstimateDetialRequest): UseQueryResult<EstimateDetailResponse, Error> => {
    let url = enum_api_uri.get_console_estimate_detail.replace(":list_no", list_no);
    return useQuery({
        queryKey: ["useGetConsoleEstimateDetail", list_no],
        queryFn: async () => {
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
        enabled: !!list_no,
    });
};
